import { StyleSheet, TouchableOpacity, View } from 'react-native';

import { IconChevronLeft, IconClose, MqSwitch, Text, XStack, YStack, tokens } from '@fhs/ui';

type GiftCardsActionSheetHeaderProps = {
  headerTitle: string;
  onPressPrev?: () => void;
  onClose?: () => void;
  disableBackButton?: boolean;
};

export function GiftCardsActionSheetHeader({
  headerTitle,
  onPressPrev,
  onClose,
  disableBackButton = false,
  ...props
}: GiftCardsActionSheetHeaderProps) {
  return (
    <MqSwitch
      $base={() => (
        <YStack>
          <View style={styles.topContainerBase}>
            <TouchableOpacity
              style={{ justifyContent: 'center' }}
              onPress={onPressPrev}
              disabled={disableBackButton}
            >
              <IconChevronLeft
                size={24}
                color={disableBackButton ? tokens.colors.$blackOpacity10 : undefined}
              />
            </TouchableOpacity>
            <XStack style={styles.baseHeader}>
              <XStack {...props} style={styles.baseHeadingContainer}>
                <Text.Heading type="four">{headerTitle}</Text.Heading>
              </XStack>
            </XStack>
            <TouchableOpacity style={{ justifyContent: 'center' }} onPress={onClose}>
              <IconClose size={24} />
            </TouchableOpacity>
          </View>
        </YStack>
      )}
      $gteDesktop={() => (
        <XStack {...props} style={styles.desktopHeadingContainer}>
          <XStack style={styles.topContainerDesktop}>
            <TouchableOpacity
              style={{ justifyContent: 'center' }}
              onPress={onPressPrev}
              disabled={disableBackButton}
            >
              <IconChevronLeft
                size={24}
                color={disableBackButton ? tokens.colors.$blackOpacity10 : undefined}
              />
            </TouchableOpacity>
            <XStack style={styles.desktopHeader}>
              <XStack {...props} style={styles.desktopSubtitleContainer}>
                <Text.Heading type="two" style={{ marginRight: 12 }}>
                  {headerTitle}
                </Text.Heading>
              </XStack>
            </XStack>
            <TouchableOpacity style={{ justifyContent: 'center' }} onPress={onClose}>
              <IconClose size={24} />
            </TouchableOpacity>
          </XStack>
        </XStack>
      )}
    />
  );
}

const styles = StyleSheet.create({
  baseHeadingContainer: {
    gap: 8,
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
  },
  desktopHeadingContainer: {
    gap: 12,
    textAlign: 'left',
    alignItems: 'center',
  },
  desktopSubtitleContainer: {
    flex: 1,
    marginLeft: 10,
  },
  baseHeader: {
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
  },
  desktopHeader: {
    justifyContent: 'flex-start',
    flex: 1,
  },
  topContainerBase: {
    flexDirection: 'row',
    paddingHorizontal: 16,
    paddingVertical: 12,
    alignItems: 'center',
    justifyContent: 'center',
  },
  topContainerDesktop: {
    flexDirection: 'row',
    flex: 1,
    padding: 28,
  },
});
